import { render, staticRenderFns } from "./DeleteFkEntityDialog.vue?vue&type=template&id=77215db5"
import script from "./DeleteFkEntityDialog.vue?vue&type=script&lang=js"
export * from "./DeleteFkEntityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports